  <template>
        <card>
           <template slot="header">
              <h3 class="card-title">Job Information</h3>
           </template>
           <div class="row">
              <div class="col-md-10">
                 <nav>
                    <ol class="breadcrumb arr-right bg-breadcrum">
                       <li class="breadcrumb-item">
                          <router-link to="/hr/dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
                       </li>
                       <li class="breadcrumb-item">
                          <router-link to="/hr/jobinformation">Job Information</router-link>
                       </li>
                       <li class="breadcrumb-item active">Details</li>
                    </ol>
                 </nav>
              </div>
              <div class="col-md-2">
                 <button @click="printItem()" class="float-right"><i class="fa fa-print"></i>Print Preview</button> 
              </div>
           </div>
           <hr style="margin-top:-10px"/>
           <div id="printMe">
              <div class="report-container">
                 <img class="logo-print" width="190" height="110" src="/static/img/blueprintlogo.png" alt="..."/><br/><br/>
                 <div class="col-md-12 report-border-full">
                    <div class="report-header">
                       <center>EMPLOYEE JOB INFORMATION</center>
                    </div>
                 </div>
                 <div class="report-gatter"></div>
                 <div class="col-md-12 report-border-full">
                    <div class="row">
                       <div class="col-md-6">
                          <p class="margin-p"><b>Employee Name:</b> {{item.first_name  | capitalize }} , {{item.last_name  | capitalize}}</p>
                          <p class="margin-p"><b>Department:</b> {{item.department_name | capitalize}}</p>
                       </div>
                       <div class="col-md-6">
                          <p class="margin-p"><b>Employee Number:</b> {{item.emp_id}}</p>
                          <p class="margin-p"><b>Position:</b> {{item.position_name | capitalize}}</p>
                       </div>
                    </div>
                 </div>
                 <div class="report-gatter"></div>
                 <div class="col-md-12 report-border-full">
                    <div class="row">
                       <div class="col-md-6">
                          <p class="margin-p"><b>Employment Date:</b> 
                             <span v-if="item.employment_date === null">_______________________</span>
                             <span v-else>{{getDate(item.employment_date)}}</span>
                          </p>
                          <p class="margin-p"><b>Signed Date:</b> 
                             <span v-if="item.date_signed === null">_______________________</span>
                             <span v-else>{{getDate(item.date_signed)}}</span>
                          </p>
                          <p class="margin-p"><b>Training Date:</b> 
                            From - <span v-if="item.training_start === null">_______________________</span>
                             <span v-else>{{getDate(item.training_start)}}</span>
                            To - <span v-if="item.training_end === null">_______________________</span>
                             <span v-else>{{getDate(item.training_end)}}</span>
                          </p>
                          <p class="margin-p"><b>Basic Salary:</b> <span>&#8369;</span>{{formatMoney(item.basic_salary)}}</p>
                          <p class="margin-p"><b>Monthly Allowance:</b><span>&#8369;</span>{{formatMoney(item.monthly_allowance)}}</p>
                       </div>
                       <div class="col-md-6">
                          <p class="margin-p"><b>Resignation Date:</b>
                             <span v-if="item.resignation_date === null">_______________________</span>
                             <span v-else>{{getDate(item.resignation_date)}}</span>
                          </p>
                          <p class="margin-p"><b>Termination Date:</b> _______________________</p>
                          <p class="margin-p"><b>Regularization Date</b> 
                             <span v-if="item.regularization_date === null">_______________________</span>
                             <span v-else>{{getDate(item.regularization_date)}}</span>
                          </p>
                          <p class="margin-p"><b>Promoted Date:</b> 
                             <span v-if="item.promoted_date === null">_______________________</span>
                             <span v-else>{{item.promoted_date}}</span>
                          </p>
                          <p class="margin-p"><b>Blueprint Status:</b> {{item.status}}</p>
                       </div>
                    </div>
                 </div>
                 <div class="report-gatter"></div>
                 <div class="col-md-12 report-border-full">
                    <b>Note / Reason:</b><br/>
                    {{item.note}}<br/><br/>
                 </div>
                 <div class="report-gatter"></div>
                 <div v-if="item.experience !== null">
                    <div class="col-md-12 report-border-full">
                       <div class="report-header">
                          <center>WORK EXPERIENCE</center>
                       </div>
                    </div>
                 </div>
                 <div class="report-gatter"></div>
                 <span v-for="(exp,i) in item.experience">
                    <p><b>From :</b> {{getDate(exp.start_date)}} <b>To :</b>{{getDate(exp.end_date)}}</p>
                    <div class="col-md-12 report-border-full">
                       <div class="row">
                          <div class="col-md-6">
                             <p><b>Employeer:</b> {{(exp.employeer)}}</p>
                             <p><b>Company Address:</b> {{exp.company_address}}</p>
                          </div>
                          <div class="col-md-6">
                             <p><b>Position:</b> {{exp.job_title}}</p>
                             <p><b>Salary:</b> <span>&#8369;</span>{{formatMoney(exp.previous_salary)}}</p>
                          </div>
                       </div>
                    </div>
                    <div class="report-gatter"></div>
                    <div class="col-md-12 report-border-full">
                       <b>Reason to leave:</b>
                       <p>{{exp.reason_for_leaving}}</p>
                    </div>
                    <br/>
                 </span>
                 <br/>
                 <p>HR FORM NO. 0003</p>
              </div>
           </div>
        </card>
     </template>
 <script>
/* eslint-disable */
import Card from 'src/components/UIComponents/Cards/Card.vue'

export default {
  components: {
    Card
  },
  data() {
    return {
      item: {},
      print: 'Hellow Wolrd'
    }

  },
  mounted: function () {
    this.fetchItem()
  },
  methods: {

    // printNow(value){
    // 	this.print = value;
    //     window.print();

    // },



    formatMoney(value) {
      let val = (value / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    printItem() {
      const prtHtml = document.getElementById('printMe').innerHTML;
      let stylesHtml = '';
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML;
      }

      // Open the print window
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');

      WinPrint.document.write(`<!DOCTYPE html>
                    <html>
                    <head>
                        ${stylesHtml}
                    </head>
                    <body>
                        ${prtHtml}
                    </body>
                    </html>`);

      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    },

    getCurentUser() {
      axios.get('api/user')
        .then(response => {
          this.users = response.data;
          if (this.users.role_id != 5) {
            this.$router.push({
              name: 'Login-Layout'
            })
          }
        })
        .catch(error => {
          console.log(error.response)
        });
    },
    fetchItem() {
      axios.get('api/jobinformation/get/' + this.$route.params.id)
        .then(resp => {
          this.item = resp.data;
        })
        .catch(error => {
          console.log(error)
        });
    }
  },

}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-job-information/todo-view-job-information.vue